/**
 * Company contact information used across all documents
 * (proposals, work orders, change orders, purchase orders)
 */
export const COMPANY_INFO = {
  name: "Associated Building Specialties, Inc.",
  address: "1785 W. 160th Ave.",
  suite: "Suite 400",
  city: "Broomfield",
  state: "CO",
  zip: "80023",
  fullAddress: "1785 W. 160th Ave. Suite 400, Broomfield, CO 80023",
  phone: "303-293-2096",
  email: "service@absinc.com",
};
